import { render, staticRenderFns } from "./CommonMemberSwitch.vue?vue&type=template&id=435b725b&scoped=true"
import script from "./CommonMemberSwitch.vue?vue&type=script&lang=js"
export * from "./CommonMemberSwitch.vue?vue&type=script&lang=js"
import style0 from "./CommonMemberSwitch.vue?vue&type=style&index=0&id=435b725b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b725b",
  null
  
)

export default component.exports